export default "__VITE_ASSET__DkHPIhGv__"